import { useEffect } from 'react';
import { dictionary } from '../../../../utils/dictionary';
import { useAuth } from '../../../../context/AuthContext';
import { useOnboardingStore } from '../../../../store/onboardingStore';
import { OrderBumpCard } from './components/OrderBumpCard';
import { UpsellCard } from './components/UpsellCard';

export type { UpsellProduct } from './types';

interface StepAdditionalOffersProps {
  isScraping?: boolean;
}

export function StepAdditionalOffers({ isScraping = false }: StepAdditionalOffersProps) {
  const { language } = useAuth();
  const { fetchPreviousProducts } = useOnboardingStore();

  useEffect(() => {
    fetchPreviousProducts();
  }, [fetchPreviousProducts]);

  return (
    <div className="space-y-6">
      <div className="text-center mb-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">
          {dictionary['increase-your-revenue-with-complementary-products'][language]}
        </h1>
      </div>

      <div className="max-w-3xl mx-auto space-y-4">
        <OrderBumpCard isScraping={isScraping} />
        <UpsellCard isScraping={isScraping} />
      </div>
    </div>
  );
}
